import { useAppDispatch, useAppSelector } from "../../app/hooks";
import classes from "./BtcUserDk.module.css";
import {
  Avatar,
  Button,
  CardActions,
  Checkbox,
  Chip,
  createTheme,
  IconButton,
  MenuItem,
  Select,
  Stack,
  ThemeProvider,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { Card, CardContent, CardHeader, Typography } from "@mui/material";
import { useEffect } from "react";
import dayjs from "dayjs";
import "dayjs/locale/en-gb";
import { logout, selectGrp, selectUsername } from "../../features/auth/authSlice";
import {
  getAllBtcDk,
  removeBtcDk,
  updateBtcDk,
} from "../../services/btc/btcApi";
import {
  deleteBtcDk,
  editBtcDk,
  selectBtc,
  setBtcDsDk,
} from "../../features/btc/btcSlice";
import { useState } from "react";
import {
  getYearCanChi,
  getYearInfo,
} from "../../utils/amlich-hnd";
import { ConfirmButton } from "../dialog/ConfirmButton.js";
import { blueGrey, purple } from "@mui/material/colors";
import BtcMenu from "../Menu/BtcMenu.js";
import { getDateAL, ngayALToDL } from "./BtcUser.js";
import { getLunarMonthStartEnd2, LularDatePicker2 } from "./ngayAl.js";
import { BtcTitle, formatN, MyBtcLayout, theme } from "./BtcAdmin.js";

function calcTotal(dk) {
  var y = 0;
  var d = 0;
  dk.dsQuy.forEach((q) => {
    if (q.donVi === "y") {
      y += parseInt(q.soLuong);
    } else if (q.donVi === "d") {
      d += parseInt(q.soLuong);
    }
  });
  const zTotal = `${formatN(y)}y, ${formatN(d)}d`;
  return zTotal;
}

const BtcHistory = ({ navigate, params = {} }) => {
  console.log("BtcHistory");
  const dispatch = useAppDispatch();
  // init
  const btc = useAppSelector(selectBtc);
  const grp = useAppSelector(selectGrp);

  // first day of month (in lunar)
  const [curDateAL] = useState(getDateAL());
  const [ngayAL, setNgayAl] = useState(() => {
    if (btc.start) {
      return getDateAL(dayjs(btc.start));
    }
    return getDateAL();
  });
  // load data
  useEffect(() => {
    var load = async () => {
      const [startAl, endAL] = getLunarMonthStartEnd2(ngayAL);
      const [start, end] = [ngayALToDL(startAl), ngayALToDL(endAL)];
      if (start === btc.start && end === btc.end) {
        // fix: sw user<> admin mode
        if (!btc.email) {
          // already admin mode
          console.log("skip load");
          return;
        }
      }
      var res = await getAllBtcDk({ start, end, grp });
      if (!res.error) {
        // btcDsDk, email, start, end
        dispatch(setBtcDsDk({ btcDsDk: res.result, start, end }));
      } else {
        console.error(res.error);
      }
    };
    load();
  }, [btc.email, btc.end, btc.start, dispatch, grp, ngayAL]);
  if (!Array.isArray(btc.btcDsDk)) {
    return <>Loading...</>
  }

  const title = <BtcTitle navigate={navigate}></BtcTitle>;
  const dsDk = btc.btcDsDk.filter(dk=>dk.deleted);
  const dsDkGroupByMs = new Map();
  dsDk.forEach((dk) => {
    dk.dsQuy.forEach((q) => {
      if (dsDkGroupByMs.has(q.msQuy)) {
        dsDkGroupByMs.get(q.msQuy)[q.donVi] += parseInt(q.soLuong);
      } else {
        var newObj = { d: 0, y: 0 };
        newObj[q.donVi] += parseInt(q.soLuong);
        dsDkGroupByMs.set(q.msQuy, newObj);
      }
    });
  });
  var dsDkTotal = { y: 0, d: 0 };
  dsDkGroupByMs.forEach((value, key) => {
    dsDkTotal.d += value.d;
    dsDkTotal.y += value.y;
  });
  const footer = <Button onClick={handleExport}>{"Sao chép tất cả"}</Button>;
  const screenOrientation = 0; // 0:landscape
  async function handleDelete(id) {
    var { error } = await removeBtcDk(id, grp);
    if (!error) {
      dispatch(deleteBtcDk({ id }));
    }
  }
  async function handleExport() {
    var msLst = Array.from(dsDkGroupByMs.keys());
    var lines = [
      "id\tngay\temail\t" + msLst.join("\t") + "\ttong\txac nhan\tghi chu",
    ];
    dsDk.forEach((dk) => {
      var dkGroupByMs = new Map();
      var dkTotal = { y: 0, d: 0 };
      msLst.forEach((ms) => dkGroupByMs.set(ms, { y: 0, d: 0 }));
      dk.dsQuy.forEach((quy) => {
        dkGroupByMs.get(quy.msQuy)[quy.donVi] += quy.soLuong;
        dkTotal[quy.donVi] += quy.soLuong;
      });
      var line = Array.from(dkGroupByMs).map(
        ([key, value]) => `${value.y}y ${value.d}d`
      );
      lines.push(
        `${dk.id}\t${dk.ngay}\t${dk.email}\t` +
          line.join("\t") +
          `\t${dkTotal.y}y ${dkTotal.d}d\t${dk.xacNhan}\t${dk.note}`
      );
    });
    // sum
    var lineSum = Array.from(dsDkGroupByMs).map(
      ([key, value]) => `${value.y}y ${value.d}d`
    );
    lines.push(
      `\t\t\t` + lineSum.join("\t") + `\t${dsDkTotal.y}y ${dsDkTotal.d}d\t\t`
    );
    await navigator.clipboard.writeText(lines.join("\n"));
  }
  async function handleRestore(id) {
    var changes = { deleted: false };
    var { error } = await updateBtcDk(id, changes, grp);
    if (!error) {
      dispatch(editBtcDk({ id, changes }));
    }
  }

  var soDuTkObj = { y: 0, d: 0 };
  const lst = dsDk
    .toSorted((a, b) => a.ngay - b.ngay)
    .map((dk) => {
      if (dk.xacNhan) {
        dk.dsQuy.forEach((q) => {
          soDuTkObj[q.donVi] += parseInt(q.soLuong);
        });
      }
      return {
        soDuTk: `${formatN(soDuTkObj.y)}y, ${formatN(soDuTkObj.d)}d`,
        dk,
      };
    });
  return (
    <MyBtcLayout title={title} footer={footer}>
      <Stack
      direction={"column"}
      spacing={{xs:1,sm:2}}
        style={
          screenOrientation
            ? { display: "flex", flexDirection: "column", height: "100%" }
            : {
                display: "flex",
                flexDirection: "column",
                height: "100%",
                overflow: "auto",
              }
        }
      >
        {LularDatePicker2(ngayAL, setNgayAl)}
        <div
          style={
            screenOrientation
              ? { flexGrow: 8, overflow: "auto" }
              : { flexGrow: 8 }
          }
        >
          <Stack direction={"column"} spacing={{xs:1,sm:2}}>
            {dsDk.map((dk, i) => (
              <BtcDkCard
                key={i}
                id={i}
                dk={dk}
                handleDelete={handleDelete}
                handleRestore={handleRestore}
                navigate={navigate}
              ></BtcDkCard>
            ))}
          </Stack>
        </div>
        <Typography variant="h5">{`Tổng cộng: ${dsDk.length}`}</Typography>
      </Stack>
    </MyBtcLayout>
  );
};
export default BtcHistory;
const BtcDkCard = ({
  dk,
  handleDelete,
  handleRestore,
  navigate,
  ...props
}) => {
  const ngayDL = dayjs(dk.ngay);
  const ngayAL = getDateAL(ngayDL);
  return (
    <div
      {...props}
      style={{
        backgroundColor: dk.bill ? "whitesmoke" : "yellow",
      }}
    >
      <Card
        style={
          dk.flag === 1
            ? { backgroundColor: theme.palette.warning.light }
            : dk.xacNhan
            ? { backgroundColor: theme.palette.primary.light }
            : {}
        }
      >
        <CardHeader
          title={
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>
                <Typography variant="h6">{`${ngayAL.day}/${
                  ngayAL.month
                }/${getYearCanChi(ngayAL.year)}`}</Typography>
                <Typography>{dk.email.replace("@gmail.com", "")}</Typography>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                }}
              >
                <Typography variant="h6" style={{ display: "inline-block" }}>
                  {calcTotal(dk)}
                </Typography>
              </div>
            </div>
          }
          subheader={<div></div>}
        ></CardHeader>

        <CardContent>
          <div style={{ margin: "0.5rem" }}>
            {dk.bill && <img alt="not found" width={"250px"} src={dk.bill} />}
            {dk.note && <div>{"Ghi chú: " + dk.note}</div>}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
            }}
          >
            {dk.dsQuy.map((quy, j) => (
              <div key={j} style={{ margin: "0.5rem" }}>
                <Chip
                  avatar={<Avatar>{quy.msQuy}</Avatar>}
                  label={`${formatN(quy.soLuong)}${quy.donVi}`}
                />
              </div>
            ))}
          </div>
        </CardContent>
        <CardActions>
            <Stack sx={{ width:"100%", justifyContent: "end", alignItems:"center", flexDirection: "row" }}>
              <Button size="small" onClick={() => handleRestore(dk.id)}>
                {"Khôi phục"}
              </Button>
              <ConfirmButton
                onOk={() => handleDelete(dk.id)}
                title={"Xác nhận xóa"}
                message={"Bạn có muốn xóa hẳn không?"}
              >
                <Button size="small">{"Xóa hẳn"}</Button>
              </ConfirmButton>
            </Stack>
        </CardActions>
      </Card>
    </div>
  );
};
